import { classNames, h } from "omi";

import { COMMUNITY_LINK } from "@/globals/links";

import "../models";

import { DocumentThemeDef } from "../models";
import type { DocumentPageProps } from "./models";

export const CoverPage = (props: DocumentPageProps) => {
  const themeDef = DocumentThemeDef[props.theme];

  return (
    <div
      class={classNames(
        "w-full max-w-screen-sm page py-12 flex flex-col justify-between overflow-y-hidden",
        themeDef.background,
      )}
    >
      <div class="items-start w-full">
        <div class="flex items-center justify-between">
          <img src={themeDef.logo} alt="" width="56" height="56" />
          <a
            href={COMMUNITY_LINK}
            target="_blank"
            class={classNames("underline text-2xl -tracking-[0.612px]", themeDef.font)}
          >
            nextwork.org
          </a>
        </div>
      </div>

      <div class="items-center my-20">
        <div class="">
          <h1 class={classNames("font-medium text-6xl w-10/12 leading-[110%]", themeDef.font)}>{props.title}</h1>
        </div>

        <div class="mt-6">
          <div
            class={classNames("w-full flex justify-between", {
              "items-center": props.userlink == null,
              "items-end": !!props.userlink,
            })}
          >
            <div class="flex items-center space-x-4">
              <img
                class="rounded-full w-14 h-14 object-cover border border-black border-opacity-80"
                width={80}
                height={80}
                src={`${props.usersavatar}`}
                alt={`${props.usersname}'s profile image`}
              />
              <div class="flex flex-col">
                <p class={classNames("text-2xl leading-9 normal-case truncate max-w-[40ch]", themeDef.font)}>
                  {props.usersname}
                </p>
                <a
                  href={makeExternalLink(props.userlink)}
                  target="_blank"
                  class={classNames("text-2xl leading-9 normal-case truncate max-w-[40ch] underline", themeDef.font, {
                    hidden: !props.userlink,
                  })}
                >
                  {props.userlink}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="block items-end">
        <slot id="content" class="w-full"></slot>
      </div>
    </div>
  );
};

/**
 * Formats a URL to be a valid external link by ensuring it has a protocol.
 * If no protocol is specified, defaults to https://.
 * @param {string | undefined} url - The URL to be formatted
 * @returns {string} - URL with protocol
 */
function makeExternalLink(url: string | undefined): string {
  if (!url) {
    return "";
  }

  const protocolPattern = /^(https?:\/\/)/;
  const hasProtocol = protocolPattern.test(url);
  return hasProtocol ? url : `https://${url}`;
}
